export default __webpack_public_path__ + "static/media/google.b3136124.png";